export default () => {
    let domainElement = document.getElementById('domain');

    domainElement.onkeyup = (event) => {
        let domain = domainElement.value.toLowerCase();

        let helpElement =  document.getElementById('domainHelp')

        if (domain.startsWith('www.')) {
            let messageElement = helpElement.getElementsByTagName('span')[0];

            let message = messageElement
                .dataset
                .domainMessage
                .replace('#DOMAIN_NAME_FULL#', domain)
                .replace('#DOMAIN_NAME#', domain.replace('www.', ''));

            messageElement.innerHTML = message;

            helpElement.style.display = 'block';
        } else {
            helpElement.style.display = 'none';
        }

        domainElement.value = domain;
    };

    document.getElementById('removeDomainPrefix').onclick = (event) => {
        let domain = domainElement.value.replace('www.', '');
        domainElement.value = domain;

        document.getElementById('domainHelp').style.display = 'none';
    }
};
